// Shared bits for the public pages (home, guide) and the in-app help.

export const BP = (process.env.NEXT_PUBLIC_BASE_PATH || "").replace(/\/+$/, "");
export const VERSION = process.env.NEXT_PUBLIC_APP_VERSION || "2.0.0";
export const APP = "/invoice/";
export const PRICE = "₹999";
export const CONTACT_EMAIL = "info@alphabettechnology.in";

// Real screenshots of the app (public/landing), taken from a demo workspace.
export const shot = (name) => `${BP}/landing/${name}.webp`;
export const asset = (file) => `${BP}/landing/${file}`;

export const CHANGELOG = [
  {
    version: "2.2.0",
    date: "October 2026",
    items: [
      "Redesigned sign-in and first-run screens",
      "Google sign-in button fits small phone screens",
    ],
  },
  {
    version: "2.1.1",
    date: "October 2026",
    items: [
      "Much lighter on your device: the Liquid glass background no longer moves, so the app stops working the graphics chip while you sit on a page",
      "Home page animations pause when they're off screen",
      "Admin panel shows a clear message instead of crashing when the account server can't be reached",
    ],
  },
  {
    version: "2.1.0",
    date: "October 2026",
    items: [
      "Continue with Google – sign in and unlock your data on any device, no password needed",
      "Connect Google Drive in one click – no Client ID to set up",
      "Your account: plan and renewal date in Settings",
      "Privacy policy page",
    ],
  },
  {
    version: "2.0.0",
    date: "October 2026",
    items: [
      "Quotations with 12 industry templates, approval links, follow-ups and a quote → invoice funnel",
      "Business type on each profile – only the options your business needs",
      "Sections, optional add-ons, product photos, line discounts and tax-inclusive prices",
      "Payment schedules with one invoice per stage",
      "Letterhead: 8 designs, ready-made letters, QR code, watermark",
      "HD company stamp and signature with one-click background removal",
      "Type-ahead services, drag-to-reorder lines, saved terms library",
      "Combined numbers when merging invoices, per-rate GST rows",
    ],
  },
  {
    version: "1.0.0",
    date: "September 2026",
    items: ["GST / VAT / export invoices, credit notes and proformas", "Automatic import of past invoices (PDF, scans, Excel)", "Google Drive sync, login with encryption, reports and tax documents vault"],
  },
];
